/**
 * Ürün KDV’si (XML / tax_rate, kdv_rate). Checkout’ta sabit %15 yerine satır bazlı hesap.
 */

/**
 * @param {object|null|undefined} product
 * @returns {number|null} 0–100 arası oran veya bilgi yoksa null
 */
export function getProductTaxRatePercent(product) {
  if (!product) return null;
  const raw = product.tax_rate ?? product.kdv_rate ?? product.vat_rate;
  if (raw === null || raw === undefined || raw === '') return null;
  const n = Number(raw);
  if (Number.isNaN(n) || n < 0) return null;
  // XML’de bazen 0.18 gibi kesir
  if (n > 0 && n < 1) return n * 100;
  return n;
}

/** Ürün fiyatının kayıtlı para birimi. Yoksa TRY (pazaryeri varsayılanı, EUR değil). */
export function productPriceCurrency(product) {
  const raw = (product?.currency || product?.original_currency || 'TRY').toString().trim().toUpperCase();
  if (!raw || raw === 'TL' || raw === '₺') return 'TRY';
  return raw;
}

/**
 * Liste fiyatına KDV dahil mi? (Ürün detayında "KDV Dahil" ile uyumlu: oran varsa varsayılan dahil.)
 * @param {object|null|undefined} product
 */
export function isVatIncludedInPrice(product) {
  if (!product) return true;
  if (product.vat_included === false) return false;
  if (product.vat_included === true) return true;
  return getProductTaxRatePercent(product) != null;
}

/**
 * Sepet satırları için: ara toplam, KDV (gösterim), KDV hariç fiyat üzerinden eklenecek tutar.
 * @param {Array<{product: object, quantity: number}>} items
 * @param {(p: object, qty: number) => number} getWholesalePrice
 * @param {(amount: number, fromCurrency: string) => number} convertPrice — kullanıcı para birimine çevir
 */
export function computeCartTaxFromItems(items, getWholesalePrice, convertPrice) {
  let subtotal = 0;
  let embeddedVat = 0;
  let taxSurcharge = 0;

  for (const item of items || []) {
    const p = item.product;
    if (!p) continue;
    const unit = getWholesalePrice(p, item.quantity);
    const cur = productPriceCurrency(p);
    const line = convertPrice(unit, cur) * (item.quantity || 1);
    subtotal += line;

    const rate = getProductTaxRatePercent(p);
    if (rate == null || rate <= 0) continue;

    if (isVatIncludedInPrice(p)) {
      embeddedVat += line * (rate / (100 + rate));
    } else {
      const v = line * (rate / 100);
      taxSurcharge += v;
      embeddedVat += v;
    }
  }

  const totalVatDisplay = embeddedVat;
  const grandTotal = subtotal + taxSurcharge;

  return {
    subtotal,
    embeddedVat,
    taxSurcharge,
    totalVatDisplay,
    grandTotal,
  };
}
